import React from "react";
import ReportTable from "../components/ReportTable";

export default function Playground() {
    const data = {
        columns: [{
            description: "c1"
        },
        {
            description: "c2"
        },
        {
            description: "c1"
        },
        {
            description: "c2"
        },
        {
            description: "c1"
        },
        {
            description: "c2"
        }],
        rows: [{
            time: "dsadas",
            description: "Dsadas",
            category: "DSADSA",
            amount: "DSAD",
            inquiry: "DSAD",
            creditCard: "DSADSA"
        },
        {

            time: "dsadas",
            description: "Dsadas",
            category: "DSADSA",
            amount: "DSAD",
            inquiry: "DSAD",
            creditCard: "DSADSA"
        },
        {

            time: "dsadas",
            description: "Dsadas",
            category: "DSADSA",
            amount: "DSAD",
            inquiry: "DSAD",
            creditCard: "DSADSA"
        },
        {

            time: "dsadas",
            description: "Dsadas",
            category: "DSADSA",
            amount: "DSAD",
            inquiry: "DSAD",
            creditCard: "DSADSA"
        },
        {

            time: "dsadas",
            description: "Dsadas",
            category: "DSADSA",
            amount: "DSAD",
            inquiry: "DSAD",
            creditCard: "DSADSA"
        },
        {

            time: "dsadas",
            description: "Dsadas",
            category: "DSADSA",
            amount: "DSAD",
            inquiry: "DSAD",
            creditCard: "DSADSA"
        }]
    };

    return (
        <ReportTable data={data} />
    );
}